
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:930px;">
    <div class="modal-header">
      <h4 class="modal-title">Select {{ title }}</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)" placeholder="{{changePlaceholder()}}"></list-controls>
      <div class="row" *ngIf="enableTaxNumberSearch">
        <div class="form-group col-lg-6" style="margin-left:1rem;">
          <input class="form-check-input" type="radio" autoLinkToLabel [checked]="customerSearchBy == 'name'" [disabled]="customerState === 1 || customerSet" [value]="name" name="customerSearchType" (click)="selectedRadioButton('name')">
          <label class="form-check-label" style="font-size:12px">Name</label>
          <input class="form-check-input" type="radio" name="customerSearchType" autoLinkToLabel [checked]="customerSearchBy == 'bpid'" [disabled]="customerState === 1 || customerSet" style="margin-left: 1rem" [value]="bpid" (click)="selectedRadioButton('bpid')">
          <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">BPID</label>
          <input class="form-check-input" type="radio" name="customerSearchType" autoLinkToLabel [checked]="customerSearchBy == 'taxNumber'" [disabled]="customerState === 1 || customerSet" style="margin-left: 1rem" [value]="taxNumber" (click)="selectedRadioButton('taxNumber')">
          <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">Tax Number</label>
        </div>
      </div>
      <table class="table table-striped" style="border-collapse: separate;">
        <thead>
          <tr *ngIf="!!customersListDisplay.length">
            <th style="width:50px;"></th>
            <th>Name</th>
            <th *ngIf="isAlternateName &amp;&amp; enableTaxNumberSearch">Alternate Name</th>
            <th>Address</th>
            <th>BP ID</th>
            <th *ngIf="isTaxNumber &amp;&amp; enableTaxNumberSearch">Tax Number</th>
            <th *ngIf="isTaxNumber &amp;&amp; enableTaxNumberSearch">Tax Number XL</th>
          </tr>
        </thead>
        <tbody>
          <ng-template [ngIf]="!loading &amp;&amp; customersListDisplay.length">
            <tr *ngFor="let customer of customersListDisplay, let i = index">
              <td class="form-group">
                <div class="form-check tmc-radio">
                  <input id="selectedCustomerRadio{{i}}" type="radio" name="selectedCustomerRadio" (change)="customerSelectedEvent(customer.bpid)" [checked]="customer.bpid === selectedCustomer.bpid">
                </div>
              </td>
              <td>{{ customer.customerName }}</td>
              <td *ngIf="isAlternateName &amp;&amp; enableTaxNumberSearch">{{ customer.alternateCustomerName }}</td>
              <td>
                <div class="col-sm-12" [hidden]="customer.name1===customer.customerName"><span>{{ customer.name1 }}</span></div>
                <div class="col-sm-12" [hidden]="!customer.name2"><span>{{ customer.name2 }}</span></div>
                <div class="col-sm-12"><span>{{ customer.line1 }}</span></div>
                <div class="col-sm-12" [hidden]="!customer.line2"><span>{{ customer.line2 }}</span></div>
                <div class="col-sm-12"><span>
                    {{ customer.city }}{{ customer.region ? ',' : '' }}
                     {{ customer.region | region }}
                     {{ customer.postalCode }}</span></div>
              </td>
              <td>{{ customer.bpid }}</td>
              <td *ngIf="isTaxNumber &amp;&amp; enableTaxNumberSearch">{{ customer.taxNumber }}</td>
              <td *ngIf="isTaxNumber &amp;&amp; enableTaxNumberSearch">{{ customer.taxNumberXL }}</td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="!loading &amp;&amp; !customersListDisplay.length">
            <tr>
              <td colspan="3">
                <p class="text-center empty-table-message">{{changeMessage()}}</p>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="loading">
            <tr>
              <td colspan="7">
                <md-spinner-block></md-spinner-block>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
      <div class="row" *ngIf="enableLocalToCentralDeals &amp;&amp; isSoldToCustomerReseller &amp;&amp; !isLeadCustomer"> 
        <div class="form-group col-lg-6" style="margin-left:1rem;">
          <input class="form-check-input" type="checkbox" autoLinkToLabel [checked]="otherCountriesSearch" (change)="SoldToInOtherCountrySearchCheckBox($event)">
          <label class="form-check-label" style="font-size:14px">Search Sold-To from other countries when searching by name</label><span class="btn btn-primary btn-circle-sm oi oi-question-mark ml-2" data-toggle="tooltip" data-placement="bottom" style="font-size:12px" (click)="SoldToInOtherCountrySearchHelp()"></span>
        </div>
      </div>
    </div>
    <div class="modal-footer" style="display: flex; justify-content: start;"><span>Selected {{ title }}: {{ selectedCustomer.customerName }}</span>
      <button class="btn btn-outline-secondary px-4 ml-auto" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary px-4" id="doneSearchCustomer" type="button" (click)="selectCustomerComplete()" [disabled]="!selectedCustomer.bpid">Done</button>
    </div>
  </div>
</div>